import debounce from "lodash.debounce";

class WindowResizeObserver {
  constructor(app) {
    this._onResize = this.onResize.bind(this);
    this._subscribers = [];
    window.addEventListener('resize', debounce(this._onResize, 300));
    this._isMobile = matchMedia("(max-width: 1023px)");
    this._app = app;
    this._app.isMobile = this._isMobile.matches;
  }
  subscribe(handler) {
    this._subscribers.push(handler);
  }
  onResize() {
    this._app.isMobile = this._isMobile.matches;
    this._subscribers.forEach(handler => handler());
  }
}

export default WindowResizeObserver;



// WEBPACK FOOTER //
// ./src/js/helpers/windowResizeObserver.js